"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class TableNode {
    static deserialize(obj) {
        return new TableNode(obj.id, obj.dataset, obj.columns, obj.joinOn);
    }
    constructor(id, dataset, columns, joinOn) {
        this.id = id;
        this.dataset = dataset;
        this.columns = columns;
        this.joinOn = joinOn;
    }
    serialize() {
        return {
            id: this.id,
            dataset: this.dataset,
            columns: this.columns,
            joinOn: this.joinOn,
        };
    }
}
exports.default = TableNode;
